import React from 'react';
import {connect} from 'react-redux';
import {Redirect} from "react-router-dom";

export default function securedAccess(Component) {

    class SecuredComponent extends React.Component {

        render() {
            if (this.props.user.isAuthenticated === true) {
                return (
                    <Component {...this.props}/>
                )
            }

            return (
                <Redirect to="/login"/>
            )
        }
    }

    const mapStateToProps = (state) => ({
        user: state.security.get('user').toJS(),
    });

    return connect(mapStateToProps)(SecuredComponent);
}



// WEBPACK FOOTER //
// ./src/admin/security/SecuredComponent.js